import { forwardRef } from 'react';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, Props>(
  function Component(props, forwardedRef) {
    return (
      <RootComponent {...props} baseClassName={css.root} ref={forwardedRef} />
    );
  }
);
